import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-settings-toggle',
  templateUrl: './settings-toggle.component.html',
  styleUrls: ['./settings-toggle.component.scss']
})
export class SettingsToggleComponent {
  @Input() caption: string;
  @Input() description: string;
}
